import { MeasurementResult } from './results';

/**
 * An outcome containing the results of a measurement.
 */
export interface MeasurementOutcome {
  results: MeasurementResult[];
  isApproximate: boolean;
}
